<span *ngIf="cardInformation?.validUntil">
  {{ 'Valid until'| translate }} : {{ cardInformation.validUntil | localeDate: 'short' }}
</span>
<span *ngIf="cardInformation?.remainingPassages > 0">
  {{ 'Remaining passages'| translate }} : {{ cardInformation.remainingPassages }}
</span>
